import React from 'react';
import ReactDomServer from 'react-dom/server';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@material-ui/icons/Close';

import Modal from 'components/Common/Modal/Modal';
import Trans from 'components/Common/Translation/Trans';

import styles from './ModalModerationPolicy.module.scss';

/**
 * Modal with iframe tag to display product size guide.
 */
function ModalModerationPolicy({
  isOpen,
  closeModal,
}: {
  /** Display modal */
  isOpen: boolean;
  /** Function call to close modal */
  closeModal: () => void;
}): JSX.Element | null {
  if (!isOpen) {
    return null;
  }
  const { t } = useTranslation();
  const sectionKeys = [
    'CONTENT_MODAL_NO_COMPENSATION',
    'CONTENT_MODAL_REVIEW_RETENTION_DURATION',
    'CONTENT_MODAL_REVIEW_CANNOT_MODIFIED',
    'CONTENT_MODAL_REVIEW_REASON_REJECTION',
  ];

  const transAdditionalComponents = {
    tcLink: (
      <a
        href={ReactDomServer.renderToString(
          <Trans
            i18nKey={'REVIEW_CONSUMER_TERMS_SERVICE_URL'}
            namespace={'review'}
          />
        )}
        target="_blank"
        rel="noreferrer nofollow noopener"
      />
    ),
    reasonRejectionLink: (
      <a
        href={ReactDomServer.renderToStaticMarkup(
          <Trans i18nKey={'REVIEW_REASON_REJECTION_URL'} namespace={'review'} />
        )}
        target="_blank"
        rel="noreferrer nofollow noopener"
      />
    ),
  };

  return (
    <Modal
      isOpen={isOpen}
      modalClassName={styles.modalContainer}
      appendInBody={true}
    >
      <div className={styles.modal}>
        <button
          className={styles.closeButton}
          type="button"
          onClick={closeModal}
          aria-label={t('LABEL_CLOSE')}
        >
          <CloseIcon
            classes={{
              root: styles.modalCloseButton,
            }}
          />
        </button>

        <div className={styles.modalHeader}>
          <h1>
            <span>
              <Trans i18nKey={'LABEL_MODAL_TITLE'} namespace={'review'} />
            </span>
          </h1>
        </div>
        <div className={styles.modalBody}>
          <Trans
            i18nKey={'CONTENT_MODAL_CONSULT_CONSUMER_TERMS_SERVICE'}
            namespace={'review'}
            additionalComponents={transAdditionalComponents}
          />
          <ul>
            {sectionKeys.map((key, index) => (
              <li key={index}>
                <Trans
                  i18nKey={key}
                  namespace={'review'}
                  additionalComponents={transAdditionalComponents}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Modal>
  );
}

export default ModalModerationPolicy;
